import {OfferListDynamic} from "../src/offer/list/components/OfferListDynamic";
import {prepareHydratedApp} from "./utils/prepare_hydrate_app";

const config = [{reactDynamic: "offer-list", view: <OfferListDynamic />}];

(() => prepareHydratedApp(config))();
